import React, { ChangeEvent, useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "./PersonalData.scss";
import { useNavigate } from "react-router-dom";
import Spinner from "../../components/widgets/UI/Spinner";

import {
  IoCheckmark,
  IoCheckmarkSharp,
  IoCloseSharp,
  IoEye,
  IoEyeOff,
  IoPeopleOutline,
  IoPersonOutline,
  IoSunnyOutline
} from "react-icons/io5";
import { ImCross } from "react-icons/im";
import RestClient from "../../@core/restClient";
import { jwtDecode } from "jwt-decode";

const PersonalData = () => {
  const [userId, setUserId] = useState("");
  const [userRole, setUserRole] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userMessage, setUserMessage] = useState("");
  const [changeData, setChangeData] = useState({
    firstName: JSON.parse(localStorage.getItem("User") || "{}")?.firstName,
    lastName: JSON.parse(localStorage.getItem("User") || "{}")?.lastName
  });
  const [passwordData, setPasswordData] = useState({
    password: "",
    newPassword: ""
  });
  const [message, setMessage] = useState(false);
  const [messageText, setMessageText] = useState("");
  const [typeOld, setTypeOld] = useState("password");
  const [typeNew, setTypeNew] = useState("password");
  const [eyeOld, setEyeOld] = useState("off");
  const [eyeNew, setEyeNew] = useState("off");
  const [sendNameDisabled, setSendNameDisabled] = useState(true);
  const [sendPasswordDisabled, setSendPasswordDisabled] = useState(true);
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmData, setConfirmData] = useState({
    email: "",
    confirmationCode: ""
  });
  const [codeWord, setCodeWord] = useState("");
  const [changingPassword, setChangingdPassword] = useState(false);
  const [changingData, setChangingData] = useState(false);
  const [deletingAccount, setDeletingAccount] = useState(false);
  const [deleteBtn, setDeleteBtn] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const smile = "\u{1F604}";

  const navigate = useNavigate();
  // GETTING USER INFO FROM LOCAL STORAGE
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("User") || "{}");
    setUserId(user.id);
    setUserEmail(user.email);

    if (user.roles[0].value === "ADMIN") {
      setUserRole("Адміністратор");
      setUserMessage(`Ви адміністратор і можете робити що хочете ${smile}`);
    } else if (user.roles[0].value === "USER") {
      setUserRole("Вільний");
      setUserMessage(
        "Користування додатком безкоштовне з обмеженнями. Ви не можете створити більше одного пісенника і бльше 15 пісень. Ви не можете завантажувати медія, створювати добірки і запрошувати учасників. Але ви можете користуватися всіма пісенниками у доступі і бути учасников у будь-яких групах."
      );
    } else if (user.roles[0].value === "SINGLE_PAID_USER") {
      setUserRole("Індивідуальний");
      setUserMessage(
        "Ви маєте розширений доступ до функціоналу додатка, але не можете запрошувати учасників і створювати команду."
      );
    } else if (user.roles[0].value === "TEAM_PAID_USER") {
      setUserRole("Командний");
      setUserMessage("Ви маєте повний доступ до всього функціоналу додатка.");
    } else if (user.roles[0].value === "UNPAID_USER") {
      setUserRole("Вільний з повним доступом");
      setUserMessage(
        `Ви маєте безкоштовний доступ до всього функціоналу додатка, бо ми маємо до вас особливе ставлення ${smile} `
      );
    }
  }, []);

  //SHOWING PASSWORD

  const toggleOld = () => {
    if (typeOld === "password") {
      setEyeOld("on");
      setTypeOld("text");
    } else {
      setEyeOld("off");
      setTypeOld("password");
    }
  };
  const toggleNew = () => {
    if (typeNew === "password") {
      setEyeNew("on");
      setTypeNew("text");
    } else {
      setEyeNew("off");
      setTypeNew("password");
    }
  };

  // CHANGING FIRST NAME OR LASTNAME
  const changePersonalData = async () => {
    try {
      setIsLoading(true);
      const response = await RestClient.changeUserData(changeData);
      localStorage.setItem("Token", response.token);
      const decodedToken: any = jwtDecode(response.token);
      localStorage.setItem("User", JSON.stringify(decodedToken));
      if (response) {
        setIsLoading(false);
        setMessage(true);
        setMessageText("Ваші дані успішно змінено!");
        setChangingData(true);
      } else {
        console.log("error");
      }
    } catch (error: any) {
      console.log(error.response.data.message);
      setIsLoading(false);
      setMessage(true);
      setMessageText("Щось пішло не так, спробуйте ще раз.");
    }
    setChangeData({
      firstName: JSON.parse(localStorage.getItem("User") || "{}")?.firstName,
      lastName: JSON.parse(localStorage.getItem("User") || "{}")?.lastName
    });
  };

  useEffect(() => {
    if (changeData.firstName || changeData.lastName) {
      setSendNameDisabled(false);
    } else setSendNameDisabled(true);
  }, [changeData]);

  //CHANGING PASSWORD

  const changePassword = async () => {
    setIsLoading(true);
    const data = { newPassword: passwordData.newPassword };
    try {
      const response = await RestClient.changeUserPassword(data);
      setIsLoading(false);
      setConfirmModal(true);
      setPasswordData({ password: "", newPassword: "" });
      setChangingdPassword(true);
    } catch (error: any) {
      console.log(error.response.data.message);
      setIsLoading(false);
      setMessage(true);
      setMessageText("Щось пішло не так, спробуйте ще раз.");
    }
  };

  useEffect(() => {
    if (passwordData.password && passwordData.newPassword) {
      setSendPasswordDisabled(false);
    } else setSendPasswordDisabled(true);
  }, [passwordData]);

  //DELETING ACCOUNT
  useEffect(() => {
    if (codeWord === "delete") {
      setDeleteBtn(false);
    } else {
      setDeleteBtn(true);
    }
  }, [codeWord]);

  const deleteAccount = async () => {
    setIsLoading(true);
    try {
      const response = await RestClient.changeUserPassword(userId);
      setIsLoading(false);
      setConfirmModal(true);
      setDeletingAccount(true);
    } catch (error: any) {
      console.log(error.response.data.message);
      setIsLoading(false);
      setMessage(true);
      setMessageText("Щось пішло не так, спробуйте ще раз.");
    }
  };

  // SENDING CONFIRMATION CODE

  const sendCode = async () => {
    setIsLoading(true);
    const codeData = { ...confirmData, email: userEmail };
    if (changingPassword) {
      try {
        const response = await RestClient.confirmChangePassword(codeData);
        localStorage.setItem("Token", response.token);
        const decodedToken: any = jwtDecode(response.token);
        localStorage.setItem("User", JSON.stringify(decodedToken));
        if (response) {
          setConfirmModal(false);
          setConfirmData({ email: "", confirmationCode: "" });
          setIsLoading(false);
          setMessage(true);
          setMessageText("Ваші дані успішно змінено!");
        } else {
          console.log("error");
        }
      } catch (error: any) {
        console.log(error.response.data.message);
        setIsLoading(false);
        setMessage(true);
        setMessageText("Щось пішло не так, спробуйте ще раз.");
      }
    } else if (deletingAccount) {
      console.log("deleting account");
    }
  };

  const cancelMessage = () => {
    setMessage(false);
    if (changingData) {
      window.location.reload();
      setChangingData(false);
    } else if (changingPassword) {
      window.location.reload();
      setChangingdPassword(false);
    } else if (deletingAccount) {
      setDeletingAccount(false);
      localStorage.clear();
      navigate("/");
    }
  };

  return (
    <div>
      <Helmet><title>Профіль | ARYN Lyrics</title></Helmet>
      <div className="pdata">
        {isLoading ? <Spinner /> : null}
        <p className="pdata-data">Зміна персональних даних</p>
        <p className="pdata-userMessage">
          Для заміни електронної адреси зверніться у підтримку. Контактна
          інформація у футері сайту.
        </p>
        <div className="pdata-form">
          <div className="pdata-form-inputs">
            <label htmlFor="name">Електронна адреса</label>
            <input
              type="email"
              name="name"
              id="name"
              value={userEmail}
              readOnly
              className="emailDisabled"
            />
            <div className="data-box">
              <div>
                <p className="data-box-subtitle">
                  Змінити Ім&apos;я або Прізвище.
                </p>
                <label htmlFor="firstName">
                  Ім&apos;я <span>*</span>
                </label>
                <input
                  type="text"
                  name="firstName"
                  id="firstName"
                  //value={""}
                  value={changeData.firstName}
                  onChange={(event: ChangeEvent<HTMLInputElement>) =>
                    setChangeData({
                      ...changeData,
                      firstName: event.target.value
                    })
                  }
                />
                <label htmlFor="lastName">
                  Прізвище <span>*</span>
                </label>
                <input
                  type="text"
                  name="lastName"
                  id="lastName"
                  //value={""}
                  value={changeData.lastName}
                  onChange={(event: ChangeEvent<HTMLInputElement>) =>
                    setChangeData({
                      ...changeData,
                      lastName: event.target.value
                    })
                  }
                />
                {/* <label htmlFor="oldPassword">
                  Чинний пароль <span>*</span>
                  {eyeOld === "off" ? (
                    <IoEye className="eyeIcon" onClick={toggleOld} />
                  ) : (
                    <IoEyeOff className="eyeIcon" onClick={toggleOld} />
                  )}
                </label>
                <input
                  type={typeOld}
                  name="oldPassword"
                  //value={""}
                  //value={changeData.password}
                  onChange={(event: ChangeEvent<HTMLInputElement>) =>
                    setChangeData({
                      ...changeData,
                      password: event.target.value
                    })
                  }
                /> */}
                <div className="pdata-form-inputs">
                  <button
                    className={
                      sendNameDisabled
                        ? "btn-mcolor-inactive pdata-form-btn"
                        : "btn-mcolor pdata-form-btn"
                    }
                    disabled={sendNameDisabled}
                    onClick={changePersonalData}
                  >
                    Відправити
                  </button>
                </div>
              </div>
              <div>
                <p className="data-box-subtitle">Змінити пароль</p>
                <label htmlFor="oldPassword">
                  Чинний пароль <span>*</span>
                  {eyeOld === "off" ? (
                    <IoEye className="eyeIcon" onClick={toggleOld} />
                  ) : (
                    <IoEyeOff className="eyeIcon" onClick={toggleOld} />
                  )}
                </label>
                <input
                  type={typeOld}
                  name="oldPassword"
                  id="oldPassword"
                  //value={""}
                  //value={changeData.password}
                  onChange={(event: ChangeEvent<HTMLInputElement>) =>
                    setPasswordData({
                      ...passwordData,
                      password: event.target.value
                    })
                  }
                />
                <label htmlFor="newPassword">
                  Новий пароль <span>*</span>
                  {eyeNew === "off" ? (
                    <IoEye className="eyeIcon" onClick={toggleNew} />
                  ) : (
                    <IoEyeOff className="eyeIcon" onClick={toggleNew} />
                  )}{" "}
                </label>
                <input
                  type={typeNew}
                  name="newPassword"
                  id="newPassword"
                  //value={""}
                  //value={changeData.newPassword}
                  onChange={(event: ChangeEvent<HTMLInputElement>) =>
                    setPasswordData({
                      ...passwordData,
                      newPassword: event.target.value
                    })
                  }
                />{" "}
                <div className="pdata-form-inputs">
                  <button
                    className={
                      sendPasswordDisabled
                        ? "btn-mcolor-inactive pdata-form-btn"
                        : "btn-mcolor pdata-form-btn"
                    }
                    disabled={sendPasswordDisabled}
                    onClick={changePassword}
                  >
                    Відправити
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {message ? (
          <div className="m-box">
            <div className="m-box-message">
              <div>
                <p className="m-box-message-ok">{messageText}</p>
              </div>
              <div>
                <button className="btn-mcolor" onClick={cancelMessage}>
                  Ok
                </button>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="pdata">
        <p className="pdata-data">Зміна тарифного плану</p>
        <p className="pdata-userMessage">
          Ваш поточний план <span className="pdata-userPlan">{userRole}</span>
          {/* <span>{userMessage}</span>) */}
        </p>
        <p className="pdata-userMessage">
          Наразі тарифні плани відключені. Всі користувачі мають безкоштовний
          доступ до всіх інструментів додатка. У подальшому деякі функції
          стануть платними. Але не хвилюйтесь, тарифи будуть зовсім невеликими{" "}
          {smile}
        </p>
        {/* <p className="pdata-userMessage">
          Ви можете перейти на інший тарифний план. Щоб відмовитись від платної
          підписки, перейдіть на тарифний план Вільний.{" "}
          <span className="pdata-canselMessage">
            (Якщо у вашому пісеннику більше 15 пісень, то при переході на
            безкоштовний план, ви зможете бачити тільки 15 перших пісень. Ви
            можете завантажити весь свій пісенник у форматі PDF або json перед
            тим, як відмовлятися від підписки.)
          </span>
        </p> */}
        <p className="pdata-userMessage">
          Нижче ви можете ознайомитись з майбутніми опціями.
        </p>

        <div className="options plans">
          <div className="options-box options-box-one">
            <IoSunnyOutline className="options-icon" />
            <p>
              Вільний <br /> <span>Безкоштовно</span>
            </p>
            <ul className="plan">
              <li className="plan-item">
                {" "}
                <IoCheckmarkSharp className="icon" />
                Один пісенник
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                15 пісень
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Режим екрану
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Вибір тональності
              </li>
              <li>
                <IoCloseSharp className="icon" />
                Завантаження файлів
              </li>
              <li>
                <IoCloseSharp className="icon" />
                Створення підбірок
              </li>
              <li>
                <IoCloseSharp className="icon" />
                Запрошення учасників
              </li>
              <li>
                {" "}
                <IoCloseSharp className="icon" />
                Створення груп
              </li>
            </ul>
            <button className="btn-mcolor-inactive change-plan-btn">
              Перейти
            </button>
          </div>
          <div className="options-box options-box-one">
            <IoPersonOutline className="options-icon" />
            <p>
              Індивідуальний <br />
              <span>...гр. / місяць</span>
            </p>
            <ul className="plan">
              <li className="plan-item">
                {" "}
                <IoCheckmarkSharp className="icon" />
                Два пісенники
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Пісень необмежено
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Режим екрану
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Вибір тональності
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Завантаження файлів
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Створення підбірок
              </li>
              <li>
                <IoCloseSharp className="icon" />
                Запрошення учасників
              </li>
              <li>
                {" "}
                <IoCloseSharp className="icon" />
                Створення груп
              </li>
            </ul>
            <button className="btn-mcolor-inactive change-plan-btn">
              Перейти
            </button>
          </div>
          <div className="options-box options-box-one">
            <IoPeopleOutline className="options-icon" />
            <p>
              Командний <br />
              <span>...гр. / місяць</span>
            </p>
            <ul className="plan">
              <li className="plan-item">
                {" "}
                <IoCheckmarkSharp className="icon" />
                Два пісенники
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Пісень необмежено
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Режим екрану
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Вибір тональності
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Завантаження файлів
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Створення підбірок
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Запрошення учасників
              </li>
              <li className="plan-item">
                {" "}
                <IoCheckmarkSharp className="icon" />
                Створення груп
              </li>
            </ul>
            <button className="btn-mcolor-inactive change-plan-btn">
              Перейти
            </button>
          </div>
        </div>
      </div>
      <div className="pdata">
        <p className="pdata-data">Видалення аккаунта</p>
        <p className="pdata-userMessage">
          Ви можете видалити свій акаунт з усіма даними. Усі пісенники та групи,
          які ви створили також будуть видалені.{" "}
        </p>
        <p className="pdata-userMessage">
          Введіть слово &quot;delete&quot; у поле вводу і натисність кнопку
          Видалити акаунт.
        </p>
        <input
          type="text"
          placeholder="delete"
          className="delete-input"
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            setCodeWord(event.target.value)
          }
        />
        <button
          className={deleteBtn ? "btn-mcolor-inactive" : "btn-mcolor"}
          disabled={deleteBtn}
        >
          Видалити акаунт
        </button>
      </div>
      {confirmModal ? (
        <div className="confirm">
          <div className="confirm-box">
            <p className="confirm-box-message">
              На вашу електронну адресу було надіслано код підтвердження.
              Введіть його у поле вводу.{" "}
            </p>
            <input
              type="text"
              value={confirmData.confirmationCode}
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                setConfirmData({
                  ...confirmData,
                  confirmationCode: event.target.value
                })
              }
            />
            <button className="btn-mcolor" onClick={sendCode}>
              Відправити
            </button>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default PersonalData;
